<div class="app-header p-g-1 p-md-1 p-lg-1 p-g-nopad">
  <div class="top-bar-item">
    <button (click)="onSideMenuClick($event)"
      [attr.aria-label]="sidebarLabel?ariaLabelCloseSidebar:ariaLabelOpenSidebar" class="hamburger-menu">
      <i class="fa fa-bars"></i>
    </button>
  </div>
</div>
<div class="p-g-11 p-md-11 p-lg-11 p-g-nopad">

  <div class="nav-right-menu">
    <p-menubar [model]="items" >
    </p-menubar>
  </div>
</div>

<p-confirmDialog header="Confirmation" icon="fa fa-question-circle" ></p-confirmDialog>
